(function () {
  if (window.VehicleFitmentUrls) {
    return;
  }

  var FITMENT_PARAM = 'filter.p.m.custom.vehicle_fitment';

  function origin() {
    return window.requestShopUrl || window.location.origin;
  }

  function isCollectionPath(pathname) {
    return /^\/collections\/[^/?#]+\/?$/.test(pathname || '');
  }

  function fallbackCollectionUrl() {
    return window.routes?.all_products_url || '/collections/all';
  }

  function baseCollectionUrl(options) {
    var collectionUrl = options?.collectionUrl;

    if (collectionUrl) {
      return {
        url: new URL(collectionUrl, origin()),
        preserveSearch: true,
      };
    }

    if (isCollectionPath(window.location.pathname)) {
      return {
        url: new URL(window.location.pathname, origin()),
        preserveSearch: true,
      };
    }

    return {
      url: new URL(fallbackCollectionUrl(), origin()),
      preserveSearch: false,
    };
  }

  function withCurrentSearch(url, preserveSearch) {
    if (preserveSearch) {
      url.search = window.location.search;
    }

    return url;
  }

  function buildFitmentCollectionUrl(fitmentGid, options) {
    var base = baseCollectionUrl(options || {});
    var url = withCurrentSearch(base.url, base.preserveSearch);

    url.searchParams.set(FITMENT_PARAM, fitmentGid);
    url.searchParams.delete('page');

    return url.toString();
  }

  function buildRemoveFitmentUrl() {
    var url = new URL(window.location.href);

    url.searchParams.delete(FITMENT_PARAM);
    url.searchParams.delete('page');

    return url.toString();
  }

  window.VehicleFitmentUrls = {
    fitmentParam: FITMENT_PARAM,
    isCollectionPath: isCollectionPath,
    buildFitmentCollectionUrl: buildFitmentCollectionUrl,
    buildRemoveFitmentUrl: buildRemoveFitmentUrl,
  };
})();
